import React, { useReducer } from 'react'
import StripeSellerContext from './sellerContext'
import StripeSellerReducer from './sellerReducer'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import {
    GET_SELLER_DETAILS,
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
} from './sellerTypes'

const StripeSellerState = (props) => {
    const initialState = {
        seller_details: null,
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(StripeSellerReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const onboardProcess = async (formData) => {
        const from = 'onboardProcess'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'seller/onboardProcess',
                    formData,
                    '',
                    'third_party/payment/stripe'
                ),
            ])
            // console.log(res)
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const onboardStatus = async (formData) => {
        const from = 'onboardStatus'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'seller/onboardStatus',
                    formData,
                    '',
                    'third_party/payment/stripe'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const processPayout = async (formData) => {
        const from = 'processPayout'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'seller/processPayout',
                    formData,
                    '',
                    'third_party/payment/stripe'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const retrieveAccount = async (formData, noAlert) => {
        const from = 'retrieveAccount'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'seller/retrieveAccount',
                    formData,
                    '',
                    'third_party/payment/stripe'
                ),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SELLER_DETAILS,
                    payload: res.data.data.responseData,
                })
            }
        } catch (err) {
            console.log('errr', err)
            resp.commonErrorResponse(from)
        }
    }

    const sourceAction = async (formData) => {
        const from = 'sourceAction'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'seller/sourceAction',
                    formData,
                    '',
                    'third_party/payment/stripe'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <StripeSellerContext.Provider
            value={{
                responseStatus: state.responseStatus,
                seller_details: state.seller_details,
                onboardProcess,
                onboardStatus,
                processPayout,
                sourceAction,
                retrieveAccount,
                clearResponse,
            }}
        >
            {props.children}
        </StripeSellerContext.Provider>
    )
}

export default StripeSellerState
